import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "../mock";

const NAV_LINKS = [
  { href: "#home", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#homas", label: "Special Homas" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header className="navbar" style={{ background: scrolled ? "rgba(255,245,236,0.96)" : "rgba(255,245,236,0.78)" }}>
        <div className="nav-inner">
          <a href="#home" className="nav-logo">
            <img src="/images/logo.webp" alt="logo" />
            <div>
              <div className="brand-name">Pandit C. S. Joshi</div>
              <div className="brand-sub">Sri Sai Raghvendra Astro</div>
            </div>
          </a>

          <nav className="nav-links">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href}>{l.label}</a>
            ))}
          </nav>

          <div className="nav-cta">
            <a href={`tel:${CONTACT.callNumber}`} className="btn btn-primary">
              <Phone size={16} /> {CONTACT.callDisplay}
            </a>
            <button className="nav-burger" onClick={() => setOpen(true)} aria-label="Open menu">
              <Menu size={20} />
            </button>
          </div>
        </div>
      </header>

      <div className={`mobile-drawer ${open ? "open" : ""}`} onClick={() => setOpen(false)}>
        <div className="mobile-drawer-panel" onClick={(e) => e.stopPropagation()}>
          <button className="mobile-drawer-close" onClick={() => setOpen(false)}>
            <X size={18} />
          </button>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>{l.label}</a>
          ))}
          <a href={`tel:${CONTACT.callNumber}`} style={{ color: "var(--plum)", fontWeight: 600 }} onClick={() => setOpen(false)}>
            <Phone size={14} style={{ display: "inline", marginRight: 6 }} />
            {CONTACT.callDisplay}
          </a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
